<template>
    <div v-cloak id="app">
        <div class="windowcontrol">
            <font-awesome-icon class="windowControlButton minimize" :icon="['fal', 'window-minimize']" @click="minimize" />
            <font-awesome-icon class="windowControlButton fullscreencontrol" :icon="['fal', isFullscreen?'compress':'expand']" @click="toggleFullscreen" />
            <font-awesome-icon class="windowControlButton closecontrol" :icon="['fal', 'times-square']" @click="exit" />
        </div>

        <permissions-styler :role="$store.state.user.role" />

        <portal-target class="sidebar" name="sidebar" />
        <portal-target class="export" name="export" />

        <div id="navigation">
            <navigation :items="items"/>
        </div>
        <div class="location">
            {{itemName}}
        </div>
        <!--<div class="routerview" v-if="$store.state.user.role">-->
            
            <!--<keep-alive>-->
                <router-view @title="pageTitle = $event" class="routerview" v-if="$store.state.user.role"/>
            <!--</keep-alive>-->
        <!--</div>-->
        <div class="routerview" v-else>
            <sequence-table/>
        </div>
        <div class="logosection">
            <img class="logo" src="./assets/logo.png">
        </div>
        <div class="controls">
            <button class="control" @click="newWorkflow">
                <svgicon icon="addWorkflow"/><br>
                <span class="label">New Workflow</span>
            </button>
            <button class="control" @click="$router.push('/samples')">
                <svgicon icon="addSample"/><br>
                <span class="label">New Samples</span>
            </button>
            <button class="control" @click="editWorkflow">
                <svgicon icon="editWorkflow"/><br>
                <span class="label">Edit Workflow</span>
            </button>
            <button @click="$api.call('status.start')" class="control small" :disabled="state.controls.start === 'disabled'" :active="state.controls.start === 'active'">
                <font-awesome-icon :icon="['fas', 'play']"/><br>
                <span class="label">Start</span>
            </button>
            <button @click="$api.call('status.haltRequest')" class="control small" :disabled="state.controls.halt === 'disabled'" :active="state.controls.halt === 'active'">
                <font-awesome-icon :icon="['fas', 'pause']" :class="haltRequest()"/><br>
                <span class="label">Pause</span>
            </button>
            <button @click="$api.call('status.stop')" class="control small" :disabled="state.controls.stop === 'disabled'" :active="state.controls.stop === 'active'">
                <font-awesome-icon :icon="['fas', 'stop']" :class="stopRequest()"/><br>
                <span class="label">Stop</span>
            </button>
            <div class="info" :class="state.color">
                <div class="text">
                   <span>{{state.text}}</span> 
                </div>
                <div class="explanation">
                    <span>{{state.explanation}}</span>
                </div>
                <div class="icons">
                    <font-awesome-icon :class="doorRequest()" :icon="['fal', $store.state.status.unlocked?'door-open':'door-closed']"/>
                    <router-link to="/missingconsumables">
                        <font-awesome-icon class="bell" :icon="['fas', 'bell']" v-if="$store.state.missingConsumables && $store.state.missingConsumables.vialTypes && $store.state.missingConsumables.vialTypes.length"/>
                    </router-link>
                    <router-link to="/maintenancemonitor">
                        <font-awesome-icon class="tools" :icon="['fal', 'wrench']" v-if="$store.state.maintenanceMonitor.filter(m => m.remainingPercentage <= 0.05).length > 0"/>
                    </router-link>
                    <router-link to="/solventmanagement">
                        <font-awesome-icon class="tools" :icon="['fal', 'flask']"/>
                    </router-link>
                </div>
                <div class="solvent1" @click="$router.push('/pumpsettings')">
                	<font-awesome-icon v-if="$store.state.status.pumpActive[0]" :icon="['far', 'sync']" class="sync" spin/>
                	<font-awesome-icon v-else :icon="['far', 'sync']" class="sync"/>
                	<span v-if="$store.state.pumps[0]">Pump1:{{$store.state.pumps[0].solvent.substring(0,30)}}</span>
                </div>
                <div class="solvent2" @click="$router.push('/pumpsettings')">
                	<font-awesome-icon v-if="$store.state.status.pumpActive[1]" :icon="['far', 'sync']" class="sync" spin/>
                	<font-awesome-icon v-else :icon="['far', 'sync']" class="sync"/>
                	<span v-if="$store.state.pumps[1]">Pump2:{{$store.state.pumps[1].solvent.substring(0,30)}}</span>
                </div>
            </div>
        </div>
        <div class="usersection">
            <user/>
        </div>
        
        <div class="footer">
            <span @click="$api.compatibilityEmit('triggerDemo')" class="version">{{$store.state.maintenancePassword?'accroma v'+$store.state.maintenancePassword.softwareVersion:'devMode'}}</span>
            <span class="serial">{{$store.state.maintenancePassword?$store.state.maintenancePassword.deviceSerialNumber:''}}</span>
            <span class="client" v-if="$store.state.decodedLicenseKey">Licensed to {{$store.state.decodedLicenseKey.customer}}</span>
        </div>
        <v-dialog/>
        <reposition/>
        <notifications position="bottom right" type="warn"/>
    </div>
</template>

<script>


    import User from './components/User'
    import Navigation from './components/Navigation'
    import WorkflowOpener from './components/WorkflowOpener'

    import PermissionsStyler from './components/PermissionsStyler'
    import SequenceTable from './components/SequenceTable'
    import ConfirmExit from './components/ConfirmExit'
    import EmergencyExit from './components/EmergencyExit'

    import computeSlots from './computeSlots'


    import './icons'


    export default {
        computed: {
            itemName(){
                if(this.pageTitle){
                    return this.pageTitle;
                }
                let name;
                this.items.forEach(item=>{
                    item.children.forEach(child=>{
                        if(this.$route.path.indexOf(child.route) === 0){
                            name = child.name;
                        }
                    })
                })
                return name;
            },
        },
        components: {
            'permissions-styler': PermissionsStyler,
            'user': User,
            'sequence-table': SequenceTable,
            'navigation': Navigation
        },
        methods:{
            minimize(){
                remote.getCurrentWindow().minimize();
            },
            exit(){
                this.$modal.show(ConfirmExit,{},{
                	width: 420, 
                	height: 190
                });
            },
            editWorkflow(){
                this.$modal.show(WorkflowOpener,{},{
                    width: 550,
                    height: 415
                });
            },
            updateStatus(){
                console.log('$store.state.status changed');
                const s = this.mapState(this.$store.state.status);
                console.log(this.$store.state.status, s)
                s.unlocked = this.$store.state.status.unlocked;
                s.safe = this.$store.state.status.safe;
                this.$set(this, 'state', s);
                if (this.$store.state.status.emergencyActive && !this.emergencySet) {
                	this.emergencySet = true;
                	this.$modal.show(EmergencyExit,{}, {width: 600, height: 320, clickToClose: false});
                }
            },
            mapState(s) {
            	var unsafeText = 'unsafe';
            	if (s.safe) {
            		unsafeText = '';
            	}
            	else{
            		if (s.emergencyActive) {
            			unsafeText = 'Emergency button engaged'
            		}
            		else if (s.portOpen) {
            			unsafeText = 'Maintenance port open'
            		}
            	}
            	if(!s.homingOk){
            		if(!s.emergencyActive && !s.portOpen){
		                return {
		                    text: 'Homing',
                            explanation: '',
		                    color: 'blue',
		                    controls: {
		                        start: 'disabled',
		                        halt:  'disabled',
		                        stop:  'disabled'
		                    }
		                }
		            }
		            else{
		            	return {
		                    text: 'Homing',
                            explanation: unsafeText,
		                    color: 'red',
		                    controls: {
		                        start: 'disabled',
		                        halt:  'disabled',
		                        stop:  'disabled'
		                    }
		                }
		            }
                }
                switch(s["statusCommandStatus"]){
                    case "init":
                    case "homing":
	                    if(s.safe){
	                        return {
	                            text: 'Initializing',
                                explanation: '',
	                            color: 'blue',
	                            controls: {
	                                start: 'disabled',
	                                halt:  'disabled',
	                                stop:  'disabled'
	                            }
	                        }
	                    }
	                    else{
	                    	return {
	                            text: 'Initializing',
                                explanation: unsafeText,
	                            color: 'red',
	                            controls: {
	                                start: 'disabled',
	                                halt:  'disabled',
	                                stop:  'disabled'
	                            }
	                        }
	                    }
                    break;
                    case "error":
                        return {
                            text: 'Error',
                            explanation: '',
                            color: 'red',
                            controls: {
                                start: 'disabled',
                                halt:  'disabled',
                                stop:  'disabled'
                            }
                        }
                    break;
                    case "suspended":
                        if(s.safe || !s.emergencyActive){
                            if(s.unlocked || s.unlockingRequest || s.unlockEventTimerActive){
                                return {
                                    text: 'Suspended',
                                    explanation: '',
                                    color: 'yellow',
                                    controls: {
                                        start: 'disabled',
                                        halt:  'disabled',
                                        stop:  'active'
                                    }
                                }
                            }
                            else{
                                if(s.safe){
                                   return {
                                        text: 'Suspended',
                                        explanation: '',
                                        color: 'yellow',
                                        controls: {
                                            start: '',
                                            halt:  'disabled',
                                            stop:  'active'
                                        }
                                    }
                                }
                                else{
                                    return {
                                        text: 'Suspended',
                                        explanation: 'Please close the door',
                                        color: 'red',
                                        controls: {
                                            start: 'disabled',
                                            halt:  'disabled',
                                            stop:  'active'
                                        }
                                    }
                                }
                            }
                        }   
                        else{
                        	return {
                                text: 'Suspended',
                                explanation: unsafeText,
                                color: 'red',
                                controls: {
                                    start: 'disabled',
                                    halt:  'disabled',
                                    stop:  'active'
                                }
                            }
                        }
                    break;
                    case "operating":
						if(s.safe){
                            return {
                                text: 'Operating',
                                explanation: '',
                                color: 'green',
                                controls: {
                                    start: 'active',
                                    halt:  '',
                                    stop:  ''
                                }
                            }
                        }
                        else{
                            return {
                                text: 'Operating',
                                explanation: unsafeText,
                                color: 'red',
                                controls: {
                                    start: 'active',
                                    halt:  'disabled',
                                    stop:  ''
                                }
                            }
                        }
                    break;
                    case "halt":
						if(s.safe || !s.emergencyActive){
                            if(s.unlocked || s.unlockingRequest || s.unlockEventTimerActive){
                                return {
                                    text: 'Paused',
                                    explanation: '',
                                    color: 'yellow',
                                    controls: {
                                        start: 'disabled',
                                        halt:  'active',
                                        stop:  ''
                                    }
                                }
                            }
                            else{
                                if(s.safe){
                                    return {
                                        text: 'Paused',
                                        explanation: '',
                                        color: 'yellow',
                                        controls: {
                                            start: '',
                                            halt:  'active',
                                            stop:  ''
                                        }
                                    }
                                }
                                else{
                                    return {
                                        text: 'Paused',
                                        explanation: 'Please close the door',
                                        color: 'red',
                                        controls: {
                                            start: 'disabled',
                                            halt:  'active',
                                            stop:  ''
                                        }
                                    }
                                }  
                            }
                        }    
                        else{
                            return {
                                text: 'Paused',
                                explanation: unsafeText,
                                color: 'red',
                                controls: {
                                    start: 'disabled',
                                    halt:  'active',
                                    stop:  ''
                                }
                            }	
                        }
                    break;
                }
                return {
                    text: 'Unknown state',
                    explanation: '',
                    color: 'grey',
                    controls: {
                        start: 'disabled',
                        halt: 'disabled',
                        stop: 'disabled'
                    }
                }
            },
            newWorkflow(){
                this.$set(this.$store.state, 'workflow', {steps:[]});
                this.$router.push('/workflow');
            },
            
            toggleFullscreen(){
                if(remote.getCurrentWindow().isMaximized()){
					this.isFullscreen = false;
					remote.getCurrentWindow().unmaximize();
                }
                else{
            		remote.getCurrentWindow().maximize();
            		this.isFullscreen = true;
                }
            },
            
            padZero(input){
                return ('00'+input).slice(-2);
            },
            
            formatDate(timestamp){
                let d = new Date(timestamp);
                return `${this.padZero(d.getDate())}.${this.padZero(d.getMonth()+1)}.${this.padZero(d.getYear()-100)} ${this.padZero(d.getHours())}:${this.padZero(d.getMinutes())}:${this.padZero(d.getSeconds())}`
            },

            haltRequest(){
            	var blinking = !this.$store.state.status.processingHalted && this.$store.state.status.haltProcessingRequest;
            	return {
            		'fa-blink':   blinking,  
            		'fa-steady': !blinking
            	}
            },
            doorRequest(){
            	var blinking = !this.$store.state.status.unlocked && this.$store.state.status.unlockingRequest;
            	return {
            		'fa-blink':   blinking,  
            		'fa-steady': !blinking
            	}
            },
            stopRequest(){
            	var blinking = !this.$store.state.status.noActiveDispatcherTask && this.$store.state.status.statusCommandStatus == "suspended" ;
            	return {
            		'fa-blink':   blinking,  
            		'fa-steady': !blinking
            	}
            },
            spinning(){
            	return 'spin';
            },
        },
        data: function(){
            return {
                pageTitle: null,
                isFullscreen: false,
                state: {
                    controls: {
                        start: 'disabled',
                        halt: 'disabled',
                        stop: 'disabled'
                    },
                },
                showUser: false,
                workflowSelector: {
                    workflow: null,
                    workflows: [],
                    versions: [],
                    version: {}
                },
                items: [
                    {
                        role: 'operator',
                        name: 'EDIT',
                        children: [
                            {
                                name: 'Sequence Table',
                                route: '/sequencetable'
                            },
                            {
                                name: 'Sample Handling',
                                route: '/samples'
                            },
                            {
                                name: 'Workflow Editor',
                                route: '/workflow'
                            },
                            {
                                name: 'Missing Consumables',
                                route: '/missingconsumables'
                            }
                        ]
                    },
                    {
                        role: 'operator',
                        name: 'SETTINGS',
                        children: [
                            {
                                name: 'Solvent Management',
                                route: '/solventmanagement'
                            },
                            {
                                name: 'Pump Settings',
                                route: '/pumpsettings'
                            },
                            {
                                name: 'Device Locking',
                                route: '/devicelocking'
                            },
                            {
                                role: 'administrator',
                                name: 'Empower',
                                route: '/empower'
                            }
                        ]
                    },
                    {
                        role: 'operator',
                        name: 'MAINTENANCE',
                        children: [
                            {
                                role: 'administrator',
                                name: 'Shaker Control',
                                route: '/shakercontrol'
                            },
                            {
                                role: 'administrator',
                                name: 'Balance Control',
                                route: '/balancecontrol'
                            },
                            {
                                role: 'administrator',
                                name: 'Centrifuge Control',
                                route: '/centrifugecontrol'
                            },
                            {
                                role: 'creator',
                                name: 'Filter Dispenser Control',
                                route: '/filterdispensercontrol'
                            },
                            {
                                role: 'administrator',
                                name: 'Uplc Feeder Control',
                                route: '/uplcfeedercontrol'
                            },
                            {
                                role: 'administrator',
                                name: 'Handler Control',
                                route: '/handlercontrol'
                            },
                            {
                                name: 'Jog',
                                route: '/jog'
                            },
                                                        {
                                role: 'creator',
                                name: 'Workflow Archive',
                                route: '/workflowarchive'
                            },
                            {
                                role: 'administrator',
                                name: 'Teaching',
                                route: '/teaching'
                            },
                            {
                            	role: 'administrator',
                                name: 'Config Admin Control',
                                route: '/configadmintool'
                            },
                            {
                                role: 'operator',
                                name: 'Maintenance Monitor',
                                route: '/maintenancemonitor'
                            }
                        ]
                    },
                    {
                        role: 'superadmin',
                        name: 'SUPERADMIN',
                        children: [
                            {
                                name: 'Reference Data Viewer',
                                route: '/referencedataviewer'
                            },
                            {
                                name: 'Input/Output Control',
                                route: '/inputoutputcontrol'
                            },
                            {
                                name: 'Layout Viewer',
                                route: '/layoutviewer'
                            }
                        ]
                    },
                    {
                        role: 'operator',
                        name: 'LOGS',
                        children: [
                            {
                                name: 'Sample Log Viewer',
                                route: '/samplelogviewer'
                            },
                            {
                                name: 'Log Monitor',
                                route: '/logmonitor'
                            },
                            {
                                name: 'User Log',
                                route: '/userlog'
                            },
                        ]
                    },
                    {
                        role: 'operator',
                        name: 'HELP',
                        children: [
                            {
                                role:  'superuser',
                                name:  'Create Ticket',
                                route: '/ticket'
                            },
                            {
                                name:  'Manual',
                                route: '/manual'
                            },
                            {
                                name:  'Maintenance Schedule',
                                route: '/maintenanceschedule'
                            },
                            {
                                name:  'Release Notes',
                                route: '/releasenotes'
                            },
                        ]
                    }
                ],
                projects: [],
                workflow: [],
                emergencySet: false,
            }
        },
        mounted(){
            this.$api.on('jog.update', data=>{
                this.$set(this.$store.state, 'jogControlAnswer', data);
            })
            this.$api.on('teaching.update', data=>{
                this.$set(this.$store.state, 'teachingPositions', data.teachingPositions);
            })
            this.$api.on('homing.update', data=>{
                this.$set(this.$store.state, 'homing', data);
            })
            this.$api.on('vialReposition.update', data=>{
                this.$set(this.$store.state, 'reposition', data.vials);
            })
            this.$api.on('status.update', data=>{
                this.$set(this.$store.state, 'status', data);
            })
            this.$api.on('deviceLocks.update', data=>{
                this.$set(this.$store.state, 'deviceLocks', data.deviceLocks);
            })
            this.$api.on('pump.update', data=>{
                this.$set(this.$store.state, 'pumps', data.pumps);
            })
            this.$api.on('empower.update', data=>{
                this.$set(this.$store.state, 'empower', data);
            })
            this.$api.on('maintenanceMonitor.update', data=>{
                this.$set(this.$store.state, 'maintenanceMonitor', data.maintenanceMonitor);
            })
             this.$api.on('solventManagement.update', data=>{
                this.$api.compatibilityEmit('updateSolvents');
            })
            this.$api.on('balanceControl.update', data=>{
                this.$set(this.$store.state, 'balanceControlCommands', data.balanceControlCommands);
            })
            this.$api.on('shakerControl.update', data=>{
                this.$set(this.$store.state, 'shaker', data.shaker);
            })
            this.$api.on('referenceDataViewer.update', data=>{
                this.$set(this.$store.state, 'referenceDataViewer', data.listItems);
            })
            this.$api.on('handlerControl.update', data=>{
                this.$set(this.$store.state, 'handlerControlCmdList', data.handlerControlCmdList);
            })
            this.$api.on('IOControlCommands.update', data=>{
                this.$set(this.$store.state, 'IOControlTaskList', data.IOControlTaskList);
            })
            this.$api.on('missingConsumables.update', data=>{
                this.$set(this.$store.state, 'missingConsumables', data);
            })
            this.$api.on('machineInfo.update', data=>{
                this.$set(this.$store.state, 'maintenancePassword', data);
            })
            this.$api.on('lcFeederCommand.update', data=>{
                this.$set(this.$store.state, 'lcFeeder', data);
            })

            this.$api.on('layout.update', data=>{
                const slots = computeSlots(data.layout);
                this.$set(this.$store.state, 'slots', slots);
            })

            this.$api.on('vials.insert', data=>{
                data.vials.forEach(vial=>{
                    this.$set(this.$store.state.vials, vial.vialID, vial);
                })
            })
            this.$api.on('vials.update', data=>{
                data.vials.forEach(vial=>{
                    this.$set(this.$store.state.vials, vial.vialID, vial);
                })
            })
            this.$api.on('vials.delete', data=>{
                data.vials.forEach(vial=>{
                    this.$delete(this.$store.state.vials, vial.vialID);
                })
            })

            this.$api.on('filterDispenser.update', data=>{
                this.$set(this.$store.state.filterDispenser, 'filter', data.filterdispenserFilterType);
            })
            
            this.$api.on('workflow.requestConfirmation', data=>{
                const that = this;
                this.$modal.show('dialog', {    
                    title: 'Workflow confirmation',
                    text: data.message,
                    buttons: [
                        {
                            title: 'Cancel'
                        },
                        {
                            title: 'Confirm',
                            handler: () => {
                                that.$modal.hide('dialog');
                                that.$api.call('workflow.confirm', {
                                    workflowID: data.workflowID,
                                })
                            },
                        }
                    ]
                })
            })


            this.$store.watch(state=>state.status, this.updateStatus, { immediate: true })
            this.$api.compatibilityOn('deleteVial', (vialID)=>{
                /*for(const module in this.$store.state.modules) {
                    for(const slot in this.$store.state.modules[module].slots){
                        console.log(this.$store.state.modules[module].slots[slot])
                        if(this.$store.state.modules[module].slots[slot].vialID === vialID){
                            this.$set(this.$store.state.modules[module].slots[slot], 'state', 'empty');
                            this.$set(this.$store.state.modules[module].slots[slot], 'type', 'undefined');
                            this.$set(this.$store.state.modules[module].slots[slot], 'lid', '');
                            this.$set(this.$store.state.modules[module].slots[slot], 'vial', null);
                        }
                    }
                }*/
                this.$delete(this.$store.state.vials, vialID);
            })
            this.$api.compatibilityOn('db', (data)=>{
                console.log('db', data)
                Object.assign(this.$store.state, data);
            })
            this.$api.compatibilityOn('vials', (vials)=>{
                Object.keys(vials).forEach(key=>{
                    this.$set(this.$store.state.vials, key, vials[key]);
                })
                console.log('VIALS',vials)
                /*
                Object.keys(vials).forEach((key)=>{
                    let vial = vials[key];
                    let slot;
                    for(const moduleKey in this.$store.state.modules){
                        for(const slotKey in this.$store.state.modules[moduleKey].slots){
                            if(slotKey === vial.slot){
                                slot = this.$store.state.modules[moduleKey].slots[slotKey];
                            }
                        }
                    }
                    
                    console.log('slot', slot, vial)
                    if(slot){
                        this.$set(slot, 'state', vial.status);
                        this.$set(slot, 'type', vial.vialType);
                        this.$set(slot, 'lid', vial.lid);
                        this.$set(slot, 'vialID', vial.vialID);
                        this.$set(slot, 'vial', vial);
                        console.log('found slot', slot)
                    }
                });*/
            })
        },
        watch: {
            '$route'(){
                this.pageTitle = null;
            }
        }
    }
</script>
<style lang="scss">
    @import 'colors.scss';
    @import 'modal.scss';
    @import '~pretty-checkbox/src/pretty-checkbox.scss';
    @import '~bootstrap-css-only/css/bootstrap.min.css';

    #app {
        user-select: none;
    }

    
    
    .footer {
        grid-area: footer;
        vertical-align: bottom;
        border-top: 2px solid $accromablue;
        position: relative;
        .version {
            position: absolute;
            left: 10px;
            top: 4px;
        }
        .serial {
            position: absolute;
            left: 50%;
            top: 4px;
        }
        .client {
            position: absolute;
            right: 10px;
            top: 4px;
        }
    }
    #app {
        & > div {
            //border: 1px dashed red;
        }
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100vh;
        color: #666666;
        .cls-1 {
            fill: $accromagrey; //ugly hack for svg icons. fix sometime :D
        }
        background-color: #fff;
        display: grid;

        grid-template-columns: 190px 1fr 180px;

        @media (min-width: 1350px){
            grid-template-columns: 190px 1fr 330px;
        }

        grid-template-rows: 131px 35px 1fr 25px;
        grid-template-areas: 
            "logo           controls    user"
            "navigation     location    export"
            "navigation     content     sidebar"
            "footer         footer      footer";
    }

    
    .routerview, #navigation {
        display: inline-block;
        vertical-align: top;
    }
    .routerview {
        grid-area: content;
        overflow-x: hidden;
        overflow-y: scroll;
    }
    #app {
        @media print {
            position: relative !important;
            overflow: visible !important;
        }
        font-family: Arial;
    }
    .content {
        padding: 5px;
    }


    #app, .accromacontrols/*.content, #headerbar, .modalwrapper*/ {
        button {
            &:not(.vue-treeselect__input){
                box-shadow: 2px 2px 5px 0px $accromagrey;
                /*transition: transform 0.1s linear;
                transition: box-shadow 0.1s linear;
                &:hover {
                    transform: translate(1px, 1px);
                    box-shadow: 2px 2px 1px 0px $accromagrey !important;
                }*/
            }
            &:disabled {
                opacity: 0.7;
            }
        }
        input {
            &:not(.vue-treeselect__input){
                background-color: #eee;
            }
        }

        button:hover {
            &:not(.vue-treeselect__input):not([disabled]){
                background-color: $accromabluehue;
            }
        }

        input, textarea, select {
            &:not(.vue-treeselect__input):focus {
                outline-color: $accromablue;
                outline-style: auto;
                outline-width: 3px;
            }
        }
        button:focus {
            outline: none;
        }
        button, input, textarea, select {
            &:disabled {
                background-color: rgba(255,255,255,0.7);
            }
        }
    }
        
    #navigation {
        grid-area: navigation;
        font-size: 1.5rem;
        overflow-y: scroll;

        border-right: 2px solid $accromablue;
        .NavigationLevel--level-0 > ul > li {
            border-bottom: 1px solid $accromablue;
        }
        .TreeNavigation {
            width: 100%;
            background-color: $accromabluehue;
        }
        .NavigationItem__router-link, .NavigationItem__label {
            color: $accromablue;
        }
        .router-link-active {
            color: #fff;
        }
        &::-webkit-scrollbar {
            display: none;
        }
    }
    .logosection {
        grid-area: logo;
        .logo {
            width: 108px;
            padding: 0;
            margin-left: calc(50% - 54px);
            box-shadow: 2px 2px 5px 0px $accromagrey;
        }
    }

    .controls {
        grid-area: controls;
        padding-top: 22px;
        display: flex;
        justify-content: space-between;
        .info {
            width: calc(100% - 558px);
            height: 85px;
            font-size: 1.5rem;
            box-shadow: 2px 2px 5px 0px $accromagrey;
            text-align: center;
            
            border-radius: 2px;
            position: relative;
            .text {
                margin-top:8px;
            }
            .explanation {
                line-height: 10px;
                font-size: 1.2rem;
            }
            &.green {
                background-color: $lid-green;
            }
            &.blue {
                background-color: $lid-blue;
            }
            &.red {
                background-color: $lid-red;
            }
            &.yellow {
                background-color: $lid-yellow;
            }
            &.grey {
                background-color: $accromagreyhuelight;
            }
            .icons {
                position: absolute;
                right: 5px;
                top: 8px;
                line-height: initial;
            }
            .bell {
                color: #ffa007;
                &:hover {
                    color: $accromablue;
                }
            }
            .sync {
                width:  10px;
                height: 10px;
            }
            .tools {
                &:hover {
                    color: $accromablue;
                }
            }
            .solvent1 {
                font-size: 12px;
                line-height: 12px;
                position: absolute;
                bottom: 18px;
                width: 100%;
                text-align: left;
                padding-left: 10px;
            }
            .solvent2 {
                font-size: 12px;
                line-height: 12px;
                position: absolute;
                bottom: 3px;
                width: 100%;
                text-align: left;
                padding-left: 10px;
            }
        }
        .control {
            position: relative;
            display: inline-block; 
            text-align: center;
            width: 85px;
            height: 85px;
            vertical-align: top;
            padding: 0;

            
            box-shadow: 2px 2px 5px 0px $accromagrey;
            &.small {
                .svg-icon, .svg-inline--fa {
                    width: 20px;
                    height: 20px;
                }
            }
            .svg-icon, .svg-inline--fa {
                width: 50px;
                height: 50px;
            }
            .label {
                font-size: 1rem;
                position: absolute;
                bottom: 1px;
                left: 50%;
                transform: translate(-50%);
                width: 100%;
            }
        }
        .control{
            &:hover:not([disabled]), &[active] {
                background-color: $accromabluehue;
            }
            &[disabled] {
                background-color: $accromagreyhuelight;
            }
        }
    }
    html {
        font-size: 12px;
        cursor: default;
    }

    .navlocation {
        position: absolute;
        top: 10px;
        left: 10px;
        font-size: 1rem;
    }
    input, button {
        padding: .375rem .75rem;
    }
    .usersection {
        grid-area: user;
    }
    button, input {
        background-color: #fff;
        border: none;
        border-radius: 2px;
        color: inherit;
    }
    

    .table td {
        padding: 0.2rem;
        height: 1.6rem;
    }

    a {
        color: inherit;
        &:hover {
            color: inherit;
        }
    }

    .content.big {
        font-size: 1rem;
    }

    @media print {
        .sidebar, #navigation, #headerbar {
            display: none;
        }
        .content, .routerview {
            width: 100vw;
            overflow: visible;
        }
    }
    .sidebar {
        grid-area: sidebar;
    }
    .export {
        grid-area: export;
    }

    .location {
        grid-area: location;
        box-shadow: 0px 5px 4px -5px $accromagrey;
        padding-left: 7px;
        color: $accromagrey;
        font-size: 2rem;
    }

    pre {
        border: 1px solid $accromagreyhue;
        padding: 3px;
        border-radius: 2px;
    }

    .smalltreeselect {
        width: 100px;
        ::v-deep {
            .vue-treeselect__placeholder, .vue-treeselect__single-value {
                line-height: 27px
            }
            .vue-treeselect__control {
                height: 28px;
            }
        }
    }

    @keyframes fa-blink {
    	0% { opacity: 1; }
     	25% { opacity: 0.5; }
     	50% { opacity: 0; }
     	75% { opacity: 0.5; }
     	100% { opacity: 1; }
 	}
	.fa-blink {
   		-webkit-animation: fa-blink 2s linear infinite;
	}
    tr, td, th {
        outline: none !important;
    }
    .VueTables__limit-field label {
        display: inline-flex
    }
    .VueTables__search-field label {
        display: inline-flex
    }
</style>


<style scoped lang="scss">


    @import 'colors.scss';

    #navigation, .location, .export {
        border-top: 2px solid $accromablue;
    }

    
    .sidebar ::v-deep {
        border-left: 2px solid $accromablue;
        padding: 5px;
        background-color: #ddd;

        input, button, textarea {
            width: 100%;
            &:not(.vue-treeselect__input){
                background-color: #fff;
            }
            &:disabled {
                opacity: 0.7;
            }
            &:not(.vue-treeselect__input):focus {
                outline-color: $accromablue;
                outline-style: auto;
                outline-width: 3px;
            }
        }
        button {
            box-shadow: 2px 2px 5px 0px $accromagrey;
            &:hover:not([disabled]) {
                background-color: $accromabluehue;
            }
        }
        textarea {
            width: 100%;
            height: 80px;
            border: none;
            resize: none;
            border-radius: 3px;
        }
    }
    .export ::v-deep {
        border-left: 2px solid $accromablue;
        background-color: #ddd;
        font-size: 2rem;
        height: 37px;
        .action {
            display: inline-block;
            margin-right: 7px;
            float: right;
            &:hover {
                color: $accromablue;
            }
        }
    }
    .multiselecttd {
        width: 100%;
        height: 40px;
    }

    .windowcontrol {
        -webkit-app-region: drag;
        width: 100vw;
        height: 22px;
        z-index: 100000;
        position: absolute;
        left: 0;
        top: 0;
        font-size: 1.5rem;

        .minimize {
            //font-size: 1.5rem;
            top: 5px;
            right: 62px;
        }
        .fullscreencontrol {
            //font-size: 1.5rem;
            top: 5px;
            right: 35px;
        }
        .closecontrol {
            top: 5px;
            right: 8px;
        }    
        .windowControlButton {
            -webkit-app-region: no-drag;
            position: absolute;
            &:hover {
                color: $accromablue;
            }
        }
    }
</style>